//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
import Sidentify from "@/pccomponents/identify";
export default {
  name: "login",
  components: {
    Sidentify,
  },
  data() {
    return {
      langguageList: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
      ],
      langVal: "htgl",
      options: [
        {
          value: "CONTRACT",
          label: this.$t("login.contact"),
        },
        {
          value: "SCM",
          label: this.$t("login.scm"),
        },
        {
          value: "PROJECT",
          label: this.$t("login.project"),
        },
        {
          value: "HR",
          label: this.$t("login.hr"),
        },
      ],
      sysid: process.env.SYS_NAME,
      userid: "",
      password: "",
      logincode: "",
      imgUrl: "",
      imgcode: "",
      identifyCode: "",
    };
  },

  methods: {
    // 切换系统语言
    changelang(value) {
      this.changeLanguage(value);
      this.langVal = this.getLanguageType();
      this.options = [
        {
          value: "CONTRACT",
          label: this.$t("login.contact"),
        },
        {
          value: "SCM",
          label: this.$t("login.scm"),
        },
        {
          value: "PROJECT",
          label: this.$t("login.project"),
        },
        {
          value: "HR",
          label: this.$t("login.hr"),
        },
      ];
    },
    // 刷新验证码图片
    async refreshCode() {
      var devflag = process.env.NODE_ENV;
      var protocol = document.location.protocol;
      var domain = window.location.host;
      var random = Math.random();
      this.imgcode = random;
      let params = {
        random: random,
        path:
          devflag === "development"
            ? process.env.API_LOGIN_ROOT
            : protocol + "//" + domain + "/" + process.env.API_LOGIN_ROOT,
      };
      let url = "getImage";
      await axios.post(url, params).then(({ data }) => {
        if (data.code == "1") {
          this.identifyCode = data.data;
        }
      });
      // var root = process.env.API_LOGIN_ROOT;
      // var timestamp = Date.parse(new Date()) / 1000;
      // this.imgUrl =
      //   root + "getImage?random=" + random + "&timestamp=" + timestamp;
    },
    // 登录方法
    async submitlogin() {
      var devflag = process.env.NODE_ENV;
      var protocol = document.location.protocol;
      var domain = window.location.host;
      if (this.userid.length <= 0) {
        this.tipError(this.$t("login.error_account_null"));
        return;
      }

      if (this.password.length <= 0) {
        this.tipError(this.$t("login.error_pwd_null"));
        return;
      }
      if (this.logincode.length <= 0) {
        this.tipError(this.$t("login.error_checkcode_null"));
        return;
      }

      let params = {
        userid: this.userid,
        logincode: this.logincode,
        password: this.password,
        provincecode: "PH",
        sysid: this.sysid,
        language: this.getLanguageType(),
        imgcode: this.imgcode,
        path:
          devflag === "development"
            ? process.env.API_LOGIN_ROOT
            : protocol + "//" + domain + "/" + process.env.API_LOGIN_ROOT,
        portalflag: "1",
      };

      let url = "login/checklogin";

      await axios.post(url, params).then(({ data }) => {
        var devflag = process.env.NODE_ENV;
        if (typeof data == "string") {
          // data = data.parseJSON();
          data = eval("(" + data + ")");
        }
        if (data.code == "1") {
          let userinfo = {
            username: this.userid,
            password: this.password,
          };
          auth.setToken(data.data.ffToken);
          //auth.setTokenByKey("ff_sysid",this.sysid);
          //根据业务来调整到指定的系统主页
          if (this.sysid === "CONTRACT") {
            window.location.href =
              devflag === "development"
                ? process.env.SYS_LINK_CONTRACT + "layout/home"
                : protocol +
                  "//" +
                  domain +
                  "" +
                  process.env.SYS_PRE_CONTRACT +
                  "layout/home";
          }
          if (this.sysid === "SCM") {
            window.location.href =
              devflag === "development"
                ? process.env.SYS_LINK_SCM + "layout/home"
                : protocol +
                  "//" +
                  domain +
                  "" +
                  process.env.SYS_PRE_SCM +
                  "layout/home";
          }
          if (this.sysid === "PROJECT") {
            window.location.href =
              devflag === "development"
                ? process.env.SYS_LINK_PROJECT + "layout/home"
                : protocol +
                  "//" +
                  domain +
                  "" +
                  process.env.SYS_PRE_PROJECT +
                  "layout/home";
          }
          if (this.sysid === "HR") {
            window.location.href =
              devflag === "development"
                ? process.env.SYS_LINK_HR + "layout/home"
                : protocol +
                  "//" +
                  domain +
                  "" +
                  process.env.SYS_PRE_HR +
                  "layout/home";
          }
        } else if (
          data.code == "3" ||
          data.code == "4" ||
          data.code == "5" ||
          data.code == "6"
        ) {
          //登录失败
          let msg = data.msg;
          this.tipError(msg);
        }
      });
    },
  },

  mounted() {
    this.langVal = this.getLanguageType();
    if (
      this.$route.query.sysid != undefined &&
      this.$route.query.sysid != null &&
      this.$route.query.sysid != ""
    ) {
      this.sysid = this.$route.query.sysid;
    }
  },
  created() {
    //跳回首页则清空session
    auth.setToken("");
    // auth.setTokenByKey("ff_sysid","");
    this.refreshCode();
  },
};



// WEBPACK FOOTER //
// ./src/login/login.vue